import script from "./QNotification.vue?vue&type=script&setup=true&lang=js"
export * from "./QNotification.vue?vue&type=script&setup=true&lang=js"

import "./QNotification.vue?vue&type=style&index=0&id=09155b0a&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend-demo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09155b0a"]])

export default __exports__